import React from 'react';
import classnames from 'classnames';

import { useConfirm } from 'model/confirm';

import WarningIcon from 'images/icon/warning-circle.inline.svg';

import Modal from '../Modal';

import styles from './index.css';

export const ConfirmComponent = ({ className, message, note, onEnter, onClose }) => (
	<div className={classnames(styles.confirm, className)}>
		<div className={styles.content}>
			<WarningIcon className={styles.icon} />
			<span>
				{message}
				<br />
				<span>{note}</span>
			</span>
		</div>
		<div className={styles.action}>
			<button className={styles.cancel} type="button" onClick={onClose}>
				取消
			</button>
			<button className={styles.enter} type="button" onClick={onEnter}>
				確認
			</button>
		</div>
	</div>
);

const Confirm = ({ className }) => {
	const [confirm, { closeConfirm, enterConfirm }] = useConfirm();

	return (
		<Modal className={styles.modal} active={confirm.active}>
			<ConfirmComponent
				className={className}
				message={confirm.message}
				note={confirm.note}
				onClose={closeConfirm}
				onEnter={enterConfirm}
			/>
		</Modal>
	);
};

export default Confirm;
